import React from 'react'
import { getLink } from '@helpers/env'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES, FIT_FINDER_HASH } from '@consts/index'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel
} from '@components/ui/Accordion'
import footerColumnsLinks from '../data'
import styles from './styles.module.scss'
import Link from '@components/ui/Link'

const FooterLinksColumns = () => {
  const isDesktop = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.DESKTOP,
    initialState: true
  })

  return (
    <Accordion
      id="FooterLinksColumns"
      classes={styles.FooterLinksColumns}
      isDisabled={isDesktop}
    >
      {footerColumnsLinks.map(link => {
        const { title, childLinks: children } = link
        return (
          <AccordionItem key={title}>
            {isDesktop ? (
              <h5 className={styles.FooterLinksColumns__title}>{title}</h5>
            ) : (
              <AccordionButton>{title}</AccordionButton>
            )}
            <AccordionPanel>
              <ul className={styles.FooterLinksColumns__list}>
                {children.map(child => {
                  if (child.url.includes(`#${FIT_FINDER_HASH}`)) {
                    return (
                      <li
                        className={styles.FooterLinksColumns__listItem}
                        key={child.title}
                      >
                        <Link
                          href={`#${FIT_FINDER_HASH}`}
                          title="Go to Fit finder"
                          underlined={false}
                        >
                          Fit Finder
                        </Link>
                      </li>
                    )
                  }
                  return (
                    <li
                      className={styles.FooterLinksColumns__listItem}
                      key={child.title}
                    >
                      <Link
                        href={child.rawUrl ? child.url : getLink(child.url)}
                        {...(child.openNewWindow && {
                          target: '_blank',
                          rel: 'noopener noreferrer'
                        })}
                        underlined={false}
                      >
                        {child.title}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </AccordionPanel>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default FooterLinksColumns
